import { isEmpty } from './generic';

const isDisabled = (text: string = '', isLoading: boolean): boolean => {
  return isEmpty(text) || isLoading;
};

const tooltipContent = (text: string, isLoading: boolean): string => {
  if (isEmpty(text)) {
    return 'No text to check';
  }
  if (isLoading) {
    return 'Checking spelling and grammar...';
  }
  return 'Fix spelling and grammar';
};

export const spellingAndGrammarUtil = {
  getStatus(options: { text: string; isLoading?: boolean }): {
    isDisabled: boolean;
    tooltipContent: string;
  } {
    return {
      isDisabled: isDisabled(options.text, !!options.isLoading),
      tooltipContent: tooltipContent(options.text, !!options.isLoading),
    };
  },
};
